import React from 'react';
import Cmi5 from '@xapi/cmi5';

const cmi5 = new Cmi5();
export const Cmi5Context = React.createContext(cmi5);
